
import { Component, Vue } from "vue-property-decorator";
import Currencies from "./components/Currencies.vue";

@Component({
  components: {
    Currencies
  }
})
export default class App extends Vue {}
